module.exports = __webpack_public_path__ + "static/img/exploit15.316eb357.png";